/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { SegmentRule } from '../SegmentRule/SegmentRule.entity';
import { SEGMENT_CONDITION_AND, SEGMENT_CONDITION_OR } from './SegmentCondition.entity.constant';

/**
 * The dxp segment condition entity type.
 */
export type EntitySegmentCondition = io.TypeOf<typeof SegmentCondition>;

/**
 * The dxp segment condition entity definition.
 * @export
 */
export const SegmentCondition = io.record(
  io.tuple([io.literal(SEGMENT_CONDITION_AND), io.literal(SEGMENT_CONDITION_OR)]),
  io.array(io.union([SegmentRule, io.unknown])),
  `SegmentCondition`,
);
